import { useCart } from '../context/CartContext';

export default function CartDrawer({ open, onClose, onCheckout }) {
  const { items, removeFromCart, updateQuantity, cartCount, subtotal, shippingCharge, total, clearCart } = useCart();

  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
        backdropFilter: 'blur(4px)', zIndex: 2000,
        animation: 'fadeIn 0.2s ease-out',
      }} />

      {/* Drawer */}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0,
        width: '100%', maxWidth: 420, background: '#FFFEF9',
        zIndex: 2001, display: 'flex', flexDirection: 'column',
        boxShadow: '-8px 0 32px rgba(0,0,0,0.12)',
        animation: 'slideInRight 0.3s ease-out',
      }}>
        <style>{`
          @keyframes slideInRight {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
        `}</style>

        {/* Header */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 24px', borderBottom: '1px solid rgba(74,124,89,0.1)',
        }}>
          <h2 style={{
            fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700,
            color: '#2D3B2D',
          }}>Your Cart ({cartCount})</h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', fontSize: 24, color: '#7A8B6F', padding: 4,
          }}>✕</button>
        </div>

        {/* Items */}
        <div style={{ flex: 1, overflow: 'auto', padding: '16px 24px' }}>
          {items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <span style={{ fontSize: 48, display: 'block', marginBottom: 16 }}>🧺</span>
              <p style={{
                fontFamily: "'Cormorant Garamond', serif", fontSize: 18, color: '#7A8B6F',
              }}>Your cart is empty</p>
              <p style={{ fontSize: 13, color: '#A8B89C', marginTop: 8 }}>
                Add some organic goodness from our collection
              </p>
            </div>
          ) : (
            items.map((item) => (
              <div key={item._id} style={{
                display: 'flex', gap: 14, padding: '14px 0',
                borderBottom: '1px solid rgba(74,124,89,0.06)',
                animation: 'fadeUp 0.3s ease-out',
              }}>
                <div style={{
                  width: 64, height: 64, borderRadius: 12,
                  background: 'linear-gradient(135deg, #EDE8D8, #D4DCCA)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 28, flexShrink: 0,
                }}>🌿</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h4 style={{
                    fontSize: 14, fontWeight: 600, color: '#2D3B2D',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  }}>{item.name}</h4>
                  <p style={{ fontSize: 12, color: '#7A8B6F', marginTop: 2 }}>
                    ₹{item.price} × {item.quantity}
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                    <button onClick={() => updateQuantity(item._id, item.quantity - 1)} style={{
                      width: 28, height: 28, borderRadius: '50%', border: '1px solid rgba(74,124,89,0.2)',
                      background: 'none', fontSize: 14, color: '#4A5A4A',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>−</button>
                    <span style={{ fontSize: 14, fontWeight: 600, minWidth: 20, textAlign: 'center' }}>
                      {item.quantity}
                    </span>
                    <button onClick={() => updateQuantity(item._id, item.quantity + 1)} style={{
                      width: 28, height: 28, borderRadius: '50%', border: '1px solid rgba(74,124,89,0.2)',
                      background: 'none', fontSize: 14, color: '#4A5A4A',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>+</button>
                    <button onClick={() => removeFromCart(item._id)} style={{
                      marginLeft: 'auto', background: 'none', border: 'none',
                      fontSize: 12, color: '#C1440E', fontWeight: 500,
                    }}>Remove</button>
                  </div>
                </div>
                <div style={{
                  fontSize: 15, fontWeight: 700, color: '#2D5A3F', flexShrink: 0,
                }}>₹{item.price * item.quantity}</div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div style={{
            padding: '20px 24px', borderTop: '1px solid rgba(74,124,89,0.1)',
            background: '#FAF8F2',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: '#7A8B6F' }}>Subtotal</span>
              <span style={{ fontSize: 14, fontWeight: 600 }}>₹{subtotal}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: '#7A8B6F' }}>Shipping</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: shippingCharge === 0 ? '#4A7C59' : '#2D3B2D' }}>
                {shippingCharge === 0 ? 'FREE' : `₹${shippingCharge}`}
              </span>
            </div>
            {shippingCharge > 0 && (
              <p style={{ fontSize: 11, color: '#A8B89C', marginBottom: 8 }}>
                Add ₹{500 - subtotal} more for free shipping
              </p>
            )}
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              padding: '12px 0', borderTop: '1px solid rgba(74,124,89,0.1)',
              marginBottom: 16,
            }}>
              <span style={{ fontSize: 16, fontWeight: 700 }}>Total</span>
              <span style={{
                fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: '#2D5A3F',
              }}>₹{total}</span>
            </div>
            <button onClick={() => { onClose(); onCheckout && onCheckout(); }} className="btn btn-primary" style={{ width: '100%', padding: '14px', fontSize: 15 }}>
              Proceed to Checkout →
            </button>
            <button onClick={clearCart} style={{
              display: 'block', width: '100%', marginTop: 10, background: 'none',
              border: 'none', fontSize: 13, color: '#A8B89C', padding: 6,
            }}>Clear Cart</button>
          </div>
        )}
      </div>
    </>
  );
}
